import { Drawer, Select, Button } from 'antd';
import Search from 'antd/es/input/Search';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  /* Ensure sensitivity drawer is below AI Cohort drawer */
  z-index: 1000;

  .ant-drawer-mask {
    z-index: 999;
  }

  .ant-drawer-wrapper-body {
    z-index: 1000;
  }

  .ant-drawer-extra {
    display: flex;
    align-self: baseline;
    padding: 10px 0;
  }
`;

export const StyledSelect = styled(Select)`
  width: fit-content;
  margin: 2px 0 0 -8px;
  box-shadow: none !important;
  box-sizing: none !important;

  .ant-select-selector {
    border: none !important;

    .ant-select-selection-item {
      font-size: 18;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .ant-menu-light.ant-menu-root.ant-menu-vertical {
    border-inline-end: none;
    border: none;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  margin-left: 10px;
`;

export const EditMetricWrapper = styled.div`
  position: sticky;
  top: 0;
  padding: 15px 0 10px;
  background: white;
  z-index: 1000;
`;

export const FooterWrapper = styled.div`
  text-align: right;
  margin: 10px;
`;

export const TitleWrapper = styled.span`
  font-weight: normal;
  font-size: 18;
  margin-right: 10px;
`;

export const AIAlert2Info = styled.div`
  padding-top: 8px;
  font-weight: normal;
  font-size: 14px;
`;

export const SensitivityNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 0 0 13px;
  font-size: 13px;
  font-weight: normal;
  color: #595959;
  line-height: 1.4;
`;

export const NewTag = styled.span`
  font-size: 0.5em;
  vertical-align: super;
  margin-left: 0.2em;
  margin-right: 4px;
  font-weight: bold;
  color: white;
  background-color: #0046ff;
  padding: 0.1em 0.4em;
  border-radius: 0.5em;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border: 1px solid #0046ff;
  box-sizing: border-box;
`;

export const BetaTag = styled.span`
  font-size: 0.5em;
  vertical-align: super;
  margin-left: 0.4em;
  font-weight: bold;
  color: white;
  background-color: #6a3fb5;
  padding: 0.1em 0.4em;
  border-radius: 0.5em;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border: 1px solid #6a3fb5;
  box-sizing: border-box;
`;

export const StyledSearch = styled(Search)`
  width: 300px;
  margin-left: 10px;
`;

export const ContentHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
`;

export const LearnMoreLink = styled.a`
  font-style: italic;
  margin-left: 4px;
`;
